'use client';

import { usePathname } from 'next/navigation';

/**
 * Hides marketing site chrome on pages that render their own:
 * - `header` (announcement bar + navbar + popup): the unlisted chart library
 *   (/{lang}/charts/) and the comp demo (/{lang}/demo/).
 * - `footer`: the comp demo only.
 * Client-side pathname check so the server chrome components stay untouched.
 */
const HIDE = {
  header: /^\/[^/]+\/(charts|demo)\/?$/,
  footer: /^\/[^/]+\/demo\/?$/,
};

export default function SiteChromeGate({
  children,
  part = 'header',
}: {
  children: React.ReactNode;
  part?: keyof typeof HIDE;
}) {
  const pathname = usePathname();
  if (HIDE[part].test(pathname ?? '')) return null;
  return <>{children}</>;
}
